import React from 'react';
import { Button } from './Button';
import { Star, Smartphone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const doctors = [
    {
        name: "Dr. Mathew Ziggs",
        role: "General Practitioner",
        exp: "20+ Years Exp.",
        image: "https://2bd20b7db6dd5db900dc830b78e06be9.cdn.bubble.io/f1765366511507x222397899102401150/doc1.png?_gl=1*1ywv4m0*_gcl_au*OTYxMjAzODg4LjE3NjUzMTUwMDg.*_ga*Njg0NDczNjkxLjE3NjUzMTUwMDg.*_ga_BFPVR2DEE2*czE3NjUzMTUwMDgkbzEkZzEkdDE3NjUzNjY0NDEkajU2JGwwJGgw"
    },
    {
        name: "Dr. Brian Sibanda",
        role: "Urologist",
        exp: "12+ Years Exp.",
        image: "https://2bd20b7db6dd5db900dc830b78e06be9.cdn.bubble.io/f1765366502156x730115842320249100/doc2.png?_gl=1*1ywv4m0*_gcl_au*OTYxMjAzODg4LjE3NjUzMTUwMDg.*_ga*Njg0NDczNjkxLjE3NjUzMTUwMDg.*_ga_BFPVR2DEE2*czE3NjUzMTUwMDgkbzEkZzEkdDE3NjUzNjY0NDEkajU2JGwwJGgw"
    },
    {
        name: "Dr. Neo Molefe",
        role: "Psychologist",
        exp: "15+ Years Exp.",
        image: "https://2bd20b7db6dd5db900dc830b78e06be9.cdn.bubble.io/f1765376733002x183464420502323900/100578.jpg?_gl=1*zvyv5o*_gcl_au*OTYxMjAzODg4LjE3NjUzMTUwMDg.*_ga*Njg0NDczNjkxLjE3NjUzMTUwMDg.*_ga_BFPVR2DEE2*czE3NjUzMTUwMDgkbzEkZzEkdDE3NjUzNzE4NDYkajU0JGwwJGgw"
    }
];

interface SpecialistsProps {
    className?: string;
}

export const Specialists: React.FC<SpecialistsProps> = ({ className = "bg-gray-50/50" }) => {
    const navigate = useNavigate();

    const handleGetApp = () => {
        navigate('/waiting-list');
    };

    return (
        <section id="doctors" className={`py-24 ${className}`}>
            <div className="container mx-auto px-6">
                <div className="text-center mb-16 space-y-4">
                    <h2 className="text-4xl md:text-5xl font-bold text-secondary">
                        Meet Our <span className="text-primary">Doctors</span>
                    </h2>
                    <p className="text-gray-500 max-w-2xl mx-auto text-lg">
                        Top-tier medical professionals available for instant video consultation via the app.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10 px-4 md:px-0">
                    {doctors.map((doc, index) => (
                        <div key={index} className="relative bg-white rounded-[2rem] p-6 text-center transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/10 hover:-translate-y-2 border border-gray-100 group">
                            
                            {/* App Availability Badge */}
                            <div className="absolute top-6 right-6 bg-green-50 text-green-600 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider flex items-center gap-1.5 border border-green-100/50">
                                <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                                On App
                            </div>

                            <div className="w-32 h-32 mx-auto rounded-full p-1 mb-6 relative">
                                <div className="absolute inset-0 bg-primary/10 rounded-full scale-110 opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                                <img src={doc.image} alt={doc.name} className="w-full h-full rounded-full object-cover relative z-10" />
                            </div>
                            
                            <div className="mb-6 space-y-1">
                                <h3 className="text-lg font-bold text-secondary">{doc.name}</h3>
                                <p className="text-xs font-bold text-primary uppercase tracking-wide">{doc.role}</p>
                                <div className="flex items-center justify-center gap-1 pt-2">
                                     {[1,2,3,4,5].map(i => <Star key={i} size={12} className="fill-yellow-400 text-yellow-400" />)}
                                     <span className="text-xs text-gray-400 ml-1 font-medium">5.0</span>
                                </div>
                                <p className="text-sm text-gray-400 pt-1">{doc.exp}</p>
                            </div>

                            <Button 
                                onClick={handleGetApp}
                                className="w-full py-3 text-sm font-bold flex items-center justify-center gap-2 bg-secondary text-white hover:bg-primary shadow-none hover:shadow-lg transition-all"
                            >
                                <Smartphone size={16} />
                                Book on App
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};